import ReactDOM from 'react-dom/client';
import App from 'App';
import reportWebVitals from 'reportWebVitals';
import UserContextProvider from 'Context/UserContextProvider';
import { AuthProvider } from 'Context/Auth/AuthContext';
import { SettingsProvider } from 'Context/Settings/SettingsContext';
import { BillProvider } from 'Context/Bill/BillContext';

const root = ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement
);
root.render(
	<UserContextProvider>
		<SettingsProvider>
			<AuthProvider>
				<BillProvider>
					<App />
				</BillProvider>
			</AuthProvider>
		</SettingsProvider>
	</UserContextProvider>
);

// If you want to start measuring performance in your app, pass a function
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
